import CustomBox from "../../../../../Components/UI/CustomBox/CustomBox/CustomBox";
import { TYPE_PRIORITY, getDetectionType } from "./enrichedThreatTypes";

import "./flatStyles.scss";

// The dashboard widget is filter tags, a copy button, a detail popup and a
// scroll container — none of which survive a print. This variant is the same
// data as one flat IOC table, ordered by detection type.
const EnrichedThreatDataTable = ({ analysisDetails, enrichedMaliciousHashes }) => {
  const enrichedCount = analysisDetails?.enriched_malicious_count || 0;

  const allItems = Array.isArray(enrichedMaliciousHashes) ? enrichedMaliciousHashes : [];

  const grouped = TYPE_PRIORITY.map(({ key, reason, value, label }) => ({
    key,
    value,
    label,
    items: allItems.filter((item) => item.reason === reason),
  }));

  // Items whose reason is not one of the known types still belong in the report
  const remaining = allItems.filter(
    (item) => !TYPE_PRIORITY.some((type) => type.reason === item.reason),
  );

  const rows = [
    ...grouped.flatMap(({ value, items }) =>
      items.map((item) => ({ ...item, detectionType: value })),
    ),
    ...remaining.map((item) => ({ ...item, detectionType: getDetectionType(item.reason) })),
  ];

  if (enrichedCount === 0 && rows.length === 0) {
    return (
      <CustomBox className="thunter-enriched-table">
        <h2 className="thunter-enriched-table__title">Enriched Threat Data</h2>
        <p className="thunter-enriched-table__empty">No enriched threat data available</p>
      </CustomBox>
    );
  }

  return (
    <CustomBox className="thunter-enriched-table">
      <h2 className="thunter-enriched-table__title">Enriched Threat Data</h2>

      <p className="thunter-enriched-table__summary">
        <strong>{enrichedCount}</strong> malicious items identified
      </p>

      <div className="thunter-enriched-table__counts">
        {grouped.map(({ key, label, items }) => (
          <span className="thunter-enriched-table__count" key={key}>
            {label}: <strong>{items.length}</strong>
          </span>
        ))}
      </div>

      <div className="thunter-enriched-table__table">
        <div className="thunter-enriched-table__head">
          <div className="thunter-enriched-table__cell thunter-enriched-table__cell--type">
            Detection Type
          </div>
          <div className="thunter-enriched-table__cell thunter-enriched-table__cell--hash">
            Hash
          </div>
          <div className="thunter-enriched-table__cell thunter-enriched-table__cell--path">
            Path
          </div>
        </div>

        <div className="thunter-enriched-table__content">
          {rows.map((row, index) => (
            <div className="thunter-enriched-table__row" key={index}>
              <div className="thunter-enriched-table__cell thunter-enriched-table__cell--type">
                {row.detectionType}
              </div>
              <div className="thunter-enriched-table__cell thunter-enriched-table__cell--hash">
                {row.hash || row.path || "Unknown"}
              </div>
              <div className="thunter-enriched-table__cell thunter-enriched-table__cell--path">
                {row.path || "-"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </CustomBox>
  );
};

export default EnrichedThreatDataTable;
